// Field lavel validation
// const required = value => value ? undefined : 'Required';
// const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;
// const maxLength15 = maxLength(15);
// const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;

// Form validation
const validate = (values) => {
  const error = {};
  if (!values.Email || values.Email.trim() === '') {
    error.Email = 'Please enter email address';
  }
  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.Email)) {
    error.Email = 'Please enter a valid email address';
  }

  if (!values.userName || values.userName.trim() === '') {
    error.userName = 'Please enter user name';
  }
  // if (values.userName) {
  //   if (values.userName.trim().length < 5) {
  //     error.userName = 'Please enter minimum 5 characters';
  //   }
  // }

  if (!values.password || values.password.trim() === '') {
    error.password = 'Please enter password';
  }
  // if (values.password) {
  //   if (values.password.trim().length < 8) {
  //     error.password = 'Please enter minimum 8 characters';
  //   }
  // }
  // To check a password between 6 to 20 characters which contain at least
  // one numeric digit,
  // one uppercase, and //(?=.*[A-Z])
  // one lowercase letter //(?=.*[a-z])

  // let passw = /^.{6,12}$/;
  // if (values.password && !passw.test(values.password)) {
  //   error.password = "Password must be between 6 and 12 characters.";
  // }

  // if (!values.confirm_password || values.confirm_password.trim() === "") {
  //   error.confirm_password = "Please enter confirm password.";
  // }
  // if (values.password && values.confirm_password && (values.password !== values.confirm_password)) {
  //   error.confirm_password = "Password doesn\'t match with confirm password.";
  // }

  // if (!values.newpassword || values.newpassword.trim() === "") {
  //   error.newpassword = "Please enter a password.";
  // }
  // if (values.newpassword && values.confirm_password && (values.newpassword !== values.confirm_password)) {
  //   error.confirm_password = "New password doesn\'t match with confirm password.";
  // }
  //
  // if (values.newpassword && values.confirm_password && (values.newpassword !== values.confirm_password)) {
  //   error.confirm_password = "New password doesn\'t match with confirm password.";
  // }

  return error;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/logins/validate.js